<template>
  <div class="location-contact">
    <div class="location-contact__photo">
      <img
        :src="location.photo"
        alt=""
      >
    </div>
    <div class="location-contact__info">
      <div class="location-contact__name">
        {{ location.name }}
      </div>
      <div class="location-contact__phone">
        {{ location.phone }}
      </div>
      <a
        class="location-contact__address"
        :href="location.map_url"
        v-html="addressHtml"
      />
      <div class="location-contact__hours">
        <div
          v-for="hours in location.hours"
          :key="hours.caption"
        >
          <span class="days">{{ hours.caption }}</span>
          <span class="hours">{{ hours.hours }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import omit from 'lodash/omit';
import toPairs from 'lodash/toPairs';
import nl2br from '../nl2br';

export default {
  name: 'LocationContact',
  props: {
    location: {
      type: Object,
      required: true,
    },
  },
  computed: {
    addressHtml() {
      return nl2br(this.location.address);
    },
    hasWeekdayHours() {
      return 'weekday' in this.location.hours;
    },
    hasWeekendHours() {
      return 'weekend' in this.location.hours;
    },
    hasHolidayHours() {
      return 'holiday' in this.location.hours;
    },
    extraHours() {
      return toPairs(omit(this.location.hours, ['weekday', 'weekend', 'holiday']));
    },
  },
};
</script>

<style lang="scss">
.location-contact {
  border-bottom: 1px solid #ccc;
  display: flex;
  flex-wrap: wrap;
  padding: 1.5rem 0 1rem 1rem;
  @media screen and (min-width: 500px) {
    flex-wrap: nowrap;
  }

  &:last-child {
    border-bottom: none;
  }

  &__photo {
    flex-basis: 100%;
    flex-grow: 1;
    flex-shrink: 1;
    margin: 0 auto .5rem;
    max-width: 120px;
    @media screen and (min-width: 500px) {
      flex-basis: 110px;
      margin: 0 1rem 0 0;
      max-width: none;
    }
  }

  &__info {
    flex-basis: 100%;
    flex-shrink: 1;
  }

  &__name {
    font-size: 1.02rem;
    font-weight: 600;
    line-height: 1.2;
    margin-bottom: .5rem;
  }

  &__phone {
    margin: .5rem 0;
  }

  &__address {
    display: inline-block;
    line-height: 1.2;
  }

  &__hours {
    font-size: .85rem;
    margin-top: .5rem;
    line-height: 1.2;

    > div {
      border-bottom: 1px dotted #ccc;
      padding: .1rem 0;

      &:last-child {
        border-bottom: none;
      }
    }

    .days {
      display: inline-block;
      text-transform: uppercase;
      vertical-align: top;
      width: 140px;
      @media screen and (min-width: 400px) {
        width: 240px;
      }
      @media screen and (min-width: 992px) {
        width: 140px;
      }
    }

    .hours {
      font-weight: 600;
    }
  }
}
</style>
